<template>
  <b-modal
    id="modal-confirm-to-change"
    class="mc-modal"
    :title="$t('routeOptimization.alert.editTitle')"
    header-bg-variant="primary"
    size="md"
    centered
  >
    <McAlert
      variant="warning"
      :html="hasTmsUserGroupScope ? $t('routeOptimization.alert.editWarningUserGroup') : $t('routeOptimization.alert.editWarning')"
      withIcon
      :withGap="false"
    />
    <p class="mt-2 p-0">
      {{ $t('routeOptimization.alert.editNote') }}
    </p>
    <p class="mt-2 p-0">
      {{ $t('routeOptimization.alert.editConfirm') }}
    </p>
    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.cancel')"
        @click="$bvModal.hide('modal-confirm-to-change')"
      />
      <McButton
        variant="primary"
        type="submit"
        :text="$t('routeOptimization.changeSettings')"
        @click="handleReoptimizeSetting"
      />
    </template>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'
import { mapGetters } from 'vuex';

export default {
  components: {
    McButton,
    McAlert,
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    hasTmsUserGroupScope() {
      return (
        this.hasAccessAll(['tms-user-group:read'])
      )
    },
  },
  methods: {
    handleReoptimizeSetting() {
      this.$router.push({
        name: 'Route Reoptimization Setting',
        params: { id: this.$route.params.id },
      })
    },
  },
}
</script>
